<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-users-cog"></i> {{ "TITLE.SIGNATORIES" | translate }}</h4>
  </div>
  <div class="card-body">
  <div class="table-responsive">
    <table class="table-sm table-bordered" style="width: 100%;">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">{{ "TABLE.HEADER.ENTERPRISE" | translate }}</th>
        <th scope="col">{{ "TABLE.HEADER.ACTION" | translate }}</th>
        <th scope="col">{{ "TABLE.HEADER.PERSON" | translate }}</th>
      </tr>
      </thead>
      <tbody cdkDropList style="margin-top: -25px"
             (cdkDropListDropped)="drop($event)">
      <tr class="container-box"
          *ngFor="let person of people; let index = index;"
          cdkDrag
          [cdkDragDisabled]="disableElements(person)"
          [cdkDragData]="person">
        <td class="custom-col-1 font-weight-bold">
          {{index + 1}}
        </td>
        <td class="custom-col-2">
          {{person.enterpriseName}}
        </td>
        <td class="custom-col-3">
          <span class="badge {{isSigner(person)?'badge-primary':'badge-warning'}}">
           <i class="{{isSigner(person)? 'fas fa-signature': 'fas fa-eye'}}"></i>
            {{getOperationDescription(person) | translate}}
          </span>
        </td>
        <td class="custom-col-4">
          {{person.fullname | translate}}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success custom-button" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}</button>
    <button type="button" class="btn btn-outline-danger custom-button" (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}</button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
